import { Divider, Grid, IconButton, makeStyles, Typography } from '@material-ui/core/';
import { Add as AddIcon, Remove as RemoveIcon } from '@material-ui/icons/';
import React from 'react';
import { useDispatch } from 'react-redux';
import * as shoppingCartActions from '~/store/legacy/actions/shoppingCartActions';
import { toPrice } from '~/utils/format';

export default LineItems;

const useStyles = makeStyles({
  itemContainer: {
    padding: '0 20px',
  },
  mealItem: {
    margin: '5px 0',
  },
  iconButton: {
    width: 30,
    height: 30,
  },
});

function LineItems(props) {
  const { meals, isEditable = true } = props;
  return (
    <Grid container direction='column'>
      <Meals meals={meals} isEditable={isEditable} />
    </Grid>
  );
}

function Meals(props) {
  const classes = useStyles();
  const { meals, isEditable } = props;
  return (
    <Grid container className={classes.itemContainer}>
      {meals.reduce((acc, meal) => {
        const mealElement = <Meal key={meal.id} meal={meal} isEditable={isEditable} />;
        return !acc
          ? [mealElement]
          : [...acc, <Divider key={meal.id + '_divier'} style={{ width: '100%' }} />, mealElement];
      }, null)}
    </Grid>
  );
}

function Meal(props) {
  const classes = useStyles();
  const { meal, isEditable } = props;
  const dispatch = useDispatch();
  const addMeal = (meal) => {
    dispatch(shoppingCartActions.incrementMealQuantity({ meal }));
  };
  const removeMeal = (meal) => {
    dispatch(shoppingCartActions.decrementMealQuantity({ meal }));
  };

  const {
    quantity,
    attributes: { name, foreignName, price },
  } = meal;

  return (
    <>
      <Grid container alignItems='center' className={classes.mealItem}>
        <Grid item xs={6}>
          <Typography variant='body1' color='primary' style={{ textTransform: 'capitalize' }}>
            {name}
          </Typography>
          <Typography variant='body1'>{foreignName}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Grid style={{ height: '100%' }} container justify='center' alignItems='center'>
            {isEditable && (
              <IconButton
                classes={{ root: classes.iconButton }}
                onClick={() => removeMeal(meal)}
                style={{ margin: '5px' }}>
                <RemoveIcon color='primary' />
              </IconButton>
            )}
            {!isEditable && <Typography variant='body1'>X</Typography>}
            <Typography variant='body1'>{quantity}</Typography>
            {isEditable && (
              <IconButton
                classes={{ root: classes.iconButton }}
                onClick={() => addMeal(meal)}
                style={{ margin: '5px' }}>
                <AddIcon color='primary' />
              </IconButton>
            )}
          </Grid>
        </Grid>
        <Grid item xs={2}>
          <Typography align='right' variant='body1'>
            {toPrice(quantity * price)}
          </Typography>
        </Grid>
        <Grid container>
          {Object.values(meal.customizationOptions).length > 0 && <Divider variant='fullWidth' />}
          {Object.values(meal.customizationOptions).map((option) => (
            <MealCustomization key={`${meal.id}-${option.id}`} option={option} />
          ))}
        </Grid>
      </Grid>
    </>
  );
}

function MealCustomization(props) {
  const { option } = props;
  const {
    quantity,
    attributes: { name, foreignName, price },
  } = option;
  return (
    <>
      <Grid container style={{ marginBottom: 10 }}>
        <Grid item xs={1} />
        <Grid item xs={5}>
          <Typography style={{ textTransform: 'capitalize' }}>
            {name} {foreignName}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography align='center'>x {quantity}</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography align='right'>{toPrice(price * quantity)}</Typography>
        </Grid>
      </Grid>
    </>
  );
}
